import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';

gsap.registerPlugin(Flip);

/** Au-delà, le clic n'est plus celui qui a déclenché cette navigation. */
const PEREMPTION = 1500;

let charge = null;

const mouvementReduit = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * Mémorise l'aperçu survolé et sa position, au moment du clic sur un projet.
 * Appelé depuis la liste, juste avant la navigation.
 */
export function preparer(src, rect) {
  if (mouvementReduit()) return;
  charge = {
    src,
    rect: { top: rect.top, left: rect.left, width: rect.width, height: rect.height },
    instant: performance.now()
  };
}

/**
 * Fait voler l'aperçu mémorisé jusqu'au visualiseur de la page projet : on ne
 * perd pas des yeux ce qu'on était en train de regarder.
 *
 * Une seule paire d'éléments par navigation — enchaîner les Flip est
 * impossible à caler proprement.
 *
 * Sans aperçu mémorisé — accès direct à l'URL, navigation au clavier, écran
 * tactile où le survol n'existe pas — la fonction ne fait rien et la page
 * s'affiche normalement.
 */
export function atterrir(conteneur) {
  const c = charge;
  charge = null;

  const cible = conteneur?.querySelector('.viewer-stage');
  if (!c || !cible || mouvementReduit()) return;
  if (performance.now() - c.instant > PEREMPTION) return;

  const vol = document.createElement('img');
  vol.src = c.src;
  vol.alt = '';
  vol.className = 'vol-projet';
  gsap.set(vol, {
    position: 'fixed',
    top: c.rect.top,
    left: c.rect.left,
    width: c.rect.width,
    height: c.rect.height
  });
  document.body.appendChild(vol);

  // Le visualiseur garde sa place dans la mise en page pendant le vol :
  // on le masque avec visibility, jamais avec display.
  conteneur.style.visibility = 'hidden';

  let termine = false;
  const rendre = () => {
    if (termine) return;
    termine = true;
    conteneur.style.visibility = '';
    vol.remove();
  };

  // Si le Flip est interrompu, le visualiseur resterait invisible à vie.
  const secours = window.setTimeout(rendre, 1600);

  const etat = Flip.getState(vol);
  const d = cible.getBoundingClientRect();
  gsap.set(vol, { top: d.top, left: d.left, width: d.width, height: d.height });

  Flip.from(etat, {
    duration: 0.7,
    ease: 'expo.inOut',
    onComplete: () => {
      window.clearTimeout(secours);
      rendre();
    },
    onInterrupt: () => {
      window.clearTimeout(secours);
      rendre();
    }
  });
}
